import React from "react";
import { Modal } from "react-bootstrap";
import { routeValidationMessage } from "../../../constants";
import RoundedButton from "../buttons/RoundedButton";

//Popup that confirms the routing from campaign flow
export default function ConfirmationPopup(props) {
  const {
    onCancel,
    onConfirm,
    message = routeValidationMessage,
    show = true,
  } = props;

  return (
    <Modal centered show={show} onHide={onCancel} className="subadmin-modal">
      <Modal.Header className="align-items-center justify-content-between subadmin-modal-header pt-4 ps-4">
        <div className="subadmin-modal-heading">Confirm</div>
      </Modal.Header>
      <Modal.Body className="">{message}</Modal.Body>
      <Modal.Footer>
        <RoundedButton onClick={onConfirm}>Confirm</RoundedButton>
        <RoundedButton variant="outlined-blue" onClick={onCancel}>
          Cancel
        </RoundedButton>
      </Modal.Footer>
    </Modal>
  );
}
